import { render, staticRenderFns } from "./confirmed.vue?vue&type=template&id=5cc7020a&"
import script from "./confirmed.vue?vue&type=script&lang=js&"
export * from "./confirmed.vue?vue&type=script&lang=js&"
import style0 from "./confirmed.vue?vue&type=style&index=0&id=5cc7020a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports